import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { SectionTitle } from './styles'

// Import Components
import { RfqWidget } from '@jelly/components'

// Styled Components via Emotion
const PricingContainer = styled.div`
	.bzWidget::before {
		border-top: 1px solid #e0e0e0;
		display: block;
		content: '';
		left: 20%;
		margin: auto;
		width: 60%;
		${({ theme }) => theme.MQ.M} {
			width: 100%;
		}
	}
`
const PricingHeader = styled.div`
	margin: 30px auto 20px auto;
	width: 90%;
	${({ theme }) => theme.MQ.M} {
		width: 100%;
	}
`
const Title = styled(SectionTitle)`
	margin-bottom: 0;
`
const SubHeader = styled.div`
	color: ${({ theme }) => theme.colors.darkGrey};
	font-size: 14px;
	margin-bottom: 20px;
	position: relative;
	text-align: center;
	top: -5px;
	${({ theme }) => theme.MQ.M} {
		font-size: 18px;
		text-align: left;
	}
`

Pricing.propTypes = {
	title: string.isRequired,
	widgetId: string.isRequired,
	slug: string,
}

/**
 * This is the Pricing component for Mega Best Picks
 * displays a header including the category name, hard coded text
 * and under is the v4 widget
 * @todo: figure out if the OurApproach section will always be provided under the widget
 *
 * @param {String} props.title    :: pricing section title field in CCM
 * @param {String} props.widgetId :: widget Id based on the category, set in CCM
 */
export function Pricing({ title, widgetId }) {
	return (
		<PricingContainer>
			{widgetId && (
				<>
					<PricingHeader>
						<Title>{title}</Title>
						<SubHeader>Fill out this questionnaire to find vendors that meet your needs.</SubHeader>
					</PricingHeader>
					<RfqWidget widgetCategoryId={widgetId} />
				</>
			)}
		</PricingContainer>
	)
}
